<template>
  <div class="card"  v-bind:class="{ 'card-selected': selected }">
      <div v-on:click="selectImage">
        <!-- <img class="card-image" :src="image.url" /> -->
        <img class="card-image" v-lazy="url" />
      </div>          
      <div class="card-text">
        <a v-on:click="imageClick">
          {{ image.name }}
        </a>
        
      </div>
      <div class="detect" v-if="image.detectText" v-on:click="detectionClick">
        <div class="tag tag-circle" v-bind:class="{ 
          'spin': image.detectText === 'pending', 
          'is-warning': image.detectText === 'pending' , 
          'is-success': image.detectText === 'done-ok' && (image.numbers && image.numbers.length > 0), 
          'is-danger': (image.numbers && image.numbers.length == 0) }">
          <i class="material-icons has-text-black" v-if="!detectionClicked">rtt</i>
        </div>
      </div>

      <div class="reviewed">
        <div class="tag tag-circle" v-bind:class="{ 
          'spin': image.reviewed === 'pending', 
          'is-warning': !image.reviewed, 
          'is-success': image.reviewed, 
          }">
          <i class="material-icons has-text-black" v-if="image.reviewed">check</i>
          <i class="material-icons has-text-black" v-if="!image.reviewed">clear</i>
        </div>
      </div>
      <!-- <pre>
        {{ image}}
      </pre> -->
      <!-- <pre>
        {{ image.texts }}
      </pre> -->
  </div>
</template>

<script>
import FileUpload from "@/components/FileUpload.vue";
import { mapState } from 'vuex'
import firebase from "firebase";
const fb = require("../firebase");
const storage = firebase.storage();
const storageRef = firebase.storage().ref();
import { EventBus } from "../services/event-bus.js";

export default {    
  props: {
    image: Object,
    selected: Boolean,
    galleryId: String,
    gallery: Object,
    currentVisibleItems: Array
  },
  
  async created() {
    this.getUrl(this.image)
  },
  watch: { 
    image: async function(newVal, oldVal) { // watch it
      this.getUrl(newVal)
    }
  },
  data() {
      return {
        url: '',
        detectionClicked: false
      };
  },
  methods : {
    imageClick() {
      EventBus.$emit('image-popup', { images: [this.image], gallery: this.gallery, currentVisibleItems: this.currentVisibleItems });
    },
    selectImage() {
      EventBus.$emit('select-image', { id: this.image.id, image: this.image });    
    },
    detectionClick() {
      EventBus.$emit('delete-detection', { id: this.image.id, image: this.image });
    },
    async getUrl(image) {
      try {
        var fileIntRef = storage.ref(`internal-galleries/${this.galleryId}/@thumb@${image.name}`);
        this.url = await fileIntRef.getDownloadURL();
      }
      catch {
        var fileRef = storage.ref(`galleries/${this.galleryId}/${image.name}`);
        this.url = await fileRef.getDownloadURL();
      }
    }
  }
}
</script>
<style scoped>
.card-image{
  max-height: 200px;
  width: 100%;
}
.card{
  font-size: 0.85rem;
  border:2px solid transparent;
  position: relative;
}
.card-text{
  padding: 0.5rem;  
  color: #6c757d;
}
.card-text a{
  color: #6c757d;
}
.gallery{
  margin-top: 1rem;
}
.card:hover{
  box-shadow: 0 0 3px rgba(0,0,0,0.1),0 6px 20px rgba(0,0,0,0.2);
}
.card:hover .card-text a{
  color: #4a4a4a;
}
.buttons i{
  margin-right: 1rem;
  font-size: 2rem;
  cursor: pointer;
}
.card-selected{
  border:2px solid #3298DC;
}
.tag-circle{
  border-radius: 50%;
  width: 26px;
  height: 26px;
  opacity: 0.9;
}
.tag-circle i{
  font-size: 16px;
}
.detect{
  position: absolute;
  top:4px;
  left: 4px;
  cursor: pointer;
}
.view-image{
  position: absolute;
  z-index: 1;
  right: 4px;
  top:4px;
  color: #4a4a4a;
}
.reviewed{
  position: absolute;
  top:4px;
  right: 4px;
}
.spin {
  animation-name: spin;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear; 
}
@keyframes spin {
    from {
        transform:rotate(0deg);
    }
    to {
        transform:rotate(360deg);
    }
}
</style>